import { Controller } from "@hotwired/stimulus"

// Manages slide cards for StoryTemplate forms.
// On submit, serialises every visible card into JSON
// and writes it into a hidden `slides_data` field.
export default class extends Controller {
  static targets = [
    "slidesContainer",
    "slide",
    "template",
    "hiddenField",
  ]
  connect() {
    this.element
      .closest("form")
      ?.addEventListener("submit", this.serialise)
  }

  disconnect() {
    this.element
      .closest("form")
      ?.removeEventListener("submit", this.serialise)
  }

  // ── Actions ─────────────────────────────────────────

  addSlide() {
    if (!this.hasTemplateTarget) return

    const html = this.templateTarget.innerHTML.replace(
      /TPL_IDX/g,
      Date.now().toString(),
    )
    this.slidesContainerTarget.insertAdjacentHTML(
      "beforeend",
      html,
    )
    this.reindex()
  }

  removeSlide(event) {
    const card = event.target.closest(
      '[data-template-slide-editor-target="slide"]',
    )
    if (!card) return
    card.remove()
    this.reindex()
  }

  slideTypeChanged(event) {
    const type = event.target.value
    const card = event.target.closest(
      '[data-template-slide-editor-target="slide"]',
    )
    if (!card) return

    const mediaField = card.querySelector("[data-media-field]")
    if (mediaField) {
      mediaField.classList.toggle("hidden", type === "text_only")
    }

    const colorFields = card.querySelector("[data-color-fields]")
    if (colorFields) {
      colorFields.classList.toggle(
        "hidden",
        type !== "text_only",
      )
    }

    const dur = card.querySelector("[data-field='duration_seconds']")
    if (dur) dur.value = type === "video" ? 30 : 5
  }

  // ── Private ─────────────────────────────────────────

  serialise = (_event) => {
    const slides = this.visibleSlides().map((card, i) => {
      const val = (sel) =>
        card.querySelector(`[data-field='${sel}']`)?.value || ""
      const slide = {
        position: i + 1,
        slide_type: val("slide_type"),
        body: val("body"),
        duration_seconds: parseInt(val("duration_seconds"), 10) || 5,
      }
      const bgColor = val("bg_color")
      const textColor = val("text_color")
      if (bgColor || textColor) {
        slide.text_style = {}
        if (bgColor) slide.text_style.bg_color = bgColor
        if (textColor) slide.text_style.text_color = textColor
      }
      return slide
    })
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = JSON.stringify(slides)
    }
  }

  reindex() {
    this.visibleSlides().forEach((card, i) => {
      const title = card.querySelector("[data-slide-title]")
      if (title) title.textContent = `Slide ${i + 1}`
    })
  }

  visibleSlides() {
    return this.slideTargets.filter(
      (s) => !s.classList.contains("hidden"),
    )
  }
}
